import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Img from "../../Assets/img/failure.png";
import Header from "../../Components/MainLayout/Header/index";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Failure extends Component {
  render() {
    return (
      <React.Fragment>
        <Header title="Home" />
        <div className="container">
          <div className="text-center h-100">
            <div
              className="py-3"
              style={{
                backgroundImage: `url(${Img})`,
                height: 350,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            ></div>
            <h6>Oh no!</h6>
            <h6>Something went wrong.</h6>
            <p className="th-12 text-danger mb-0">
              We weren't able to process your payment.
            </p>
            <p className="th-12 text-danger">Please try again.</p>
            <div className="pb-5">
              <Link className="text-success th-14" to="/payments">
                <i
                  className="fa fa-long-arrow-left pr-3"
                  aria-hidden="true"
                ></i>
                Try again
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(Failure);
